<template>
	<section class="menu-type__wrapper" :style="'display: flex;overflow-x: auto;background-color: ' + restColor">
		<content-container>
			<ul class="menu-type__menus">
				<li v-for="menu in menuTypesObject" :key="menu.label" class="menu-type__filter" :class="{ active: menu.isActive }">
					<button :class="[{ active: menu.isActive }, 'menu-type__item']" @click="handleClick(menu)">
						{{ menu.label }}
					</button>
				</li>
			</ul>
		</content-container>
	</section>
</template>

<script>
import ContentContainer from "./ContentContainer.vue";

export default {
	name: "MenuTypeTabs",
	components: {
		ContentContainer,
	},
	props: {
		menuTypes: {
			type: Array,
			default: () => [],
		},
		restColor: {
			type: String,
			default: "#0184c6",
		},
	},
	data: function () {
		return {
			menuTypesObject: this.menuTypes,
		};
	},
	methods: {
		handleClick: function (selected) {
			this.menuTypesObject.forEach((menu) => {
				if (menu.isActive === true) {
					menu.isActive = false;
				}
			});

			selected.isActive = true;
			this.$emit("handle-menu-switch", selected.id);
		},
	},
};
</script>

<style scoped lang="scss">
.menu-type__menus {
	display: flex;
	margin-bottom: 0;
	padding-top: 0.5em;
}

.menu-type__filter {
	display: flex;
	align-items: center;
	flex-direction: row;
	justify-content: center;
}

.menu-type__filter ~ .menu-type__filter {
	margin-left: 10px;
}

.menu-type__item {
	font-weight: 900;
	font-size: 22px !important;
	color: $white;
	text-decoration: none;
	width: max-content;

	&:hover {
		color: $white;
		text-decoration: underline;
	}
}

.menu-type__item.active {
	color: $black;
	background-color: $white;
	height: 40px;
	padding: 0 10px;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;

	&:hover {
		color: $black;
		text-decoration: none;
	}
}
</style>
